<script setup>
import {useRoute} from "vue2-helpers/vue-router";
import trackersService from "@/services/trackers.service";
import {onMounted, ref} from "vue";
import AddStartup from "./OpportunityAddStartup.vue";
// import StartupsTable from "@/views/opportunities/components/StartupsTable/index.vue";
import PostedBy from "@/views/opportunities/PostedBy.vue";
import {getLogo} from "@/helpers/logo";
import StartupsTable from "@/views/opportunities/OpportunityStartups.vue";
import trackersCompaniesService from "@/services/trackers-companies.service";
import trackersCompanies from "@/services/trackers-companies.service";
import CustomFieldValue from "@/components/customFields/CustomFieldValue.vue";
import ClampedHtml from "@/components/ui/ClampedHtml.vue";

const route = useRoute();
const opportunityId = route.params.opportunityId;

const opportunity = ref(null);
const search = ref('');
const startups = ref([]);
const hasStartups = ref(null);
const startupsLoading = ref(false);
const removingStartupId = ref(null);
const addStartup = ref(null);

onMounted(() => {
    getData();
})

async function getData() {
    hasStartups.value = null;
    await getInfo();
    await getStartups();
}

async function getInfo() {
    const {data} = await trackersService.getInfo(opportunityId);
    opportunity.value = data;
}

async function getStartups() {
    startupsLoading.value = true;
    const {data} = await trackersCompaniesService.getListForOpportunity(opportunity.value.id, {search: search.value});

    if (hasStartups.value === null) {
        hasStartups.value = !!data.length;
    }

    startups.value = data;
    startupsLoading.value = false;
}

async function removeStartup(id) {
    if (confirm("Startup will be removed from tracker. Do you want to proceed?")) {
        removingStartupId.value = id;
        await trackersCompanies.removeCompanies(opportunity.value.id, [id]);

        removingStartupId.value = null;
        startups.value = startups.value.filter(item => item.id !== id);
        getData();
    }
}
</script>

<template>
    <div>
        <div class="topbar">
            <h2 class="heading2">
                <router-link class="link-back-big" to="/opportunities">All opportunities</router-link>
            </h2>
        </div>

        <main class="page-startup">
            <section class="page-startup__content loading__spinner" v-if="!opportunity">
                <span><b-spinner class="mb-1 mr-2" small></b-spinner>Loading...</span>
            </section>

            <section v-else class="page-startup__content" >
                <header class="page-startup__header">
                    <div class="image-block-wrapper">
                        <div class="image-block image-block--md">
                            <img :src="getLogo(opportunity.company_logo)" :alt="opportunity.name">
                        </div>

                        <div>
                            <h2 class="page-startup__heading2">{{ opportunity.name }}</h2>

                            <h3 class="page-startup__heading3">{{ opportunity.company_name }}</h3>
                        </div>
                    </div>

                    <a
                        class="button button--link"
                        @click="addStartup.open()"
                    >
                        Submit Startup
                    </a>
                </header>

                <AddStartup
                    ref="addStartup"
                    :opportunity-id="opportunity.id"
                    @startupAdded="getData"
                />

                <p>
                    <ClampedHtml
                        v-if="opportunity.description"
                        :max-length="3"
                        :value="opportunity.description.replace(/<[^>]*>/g, '')"
                        :raw-value="opportunity.description"
                    />
                </p>

                <div class="mb-4">
                    <div v-for="field in opportunity.submitter_fields" :key="field.field.id" class="d-flex flex-wrap align-items-center mb-2">
                        <div class="feature-title mr-1"><b>{{ field.field.name }}:</b></div>
                        <div class="feature-value">
                            <CustomFieldValue
                                :field="field.field"
                                :init-value="field.value"
                                :editable="false"
                                :collapse-text="true"
                            />
                        </div>
                    </div>
                </div>

                <div v-if="hasStartups">
                    <form class="form-search form-search--inline">
                        <label for="fsi">My Submitted Startups</label>

                        <input id="fsi" placeholder="Search" v-debounce:500="getStartups" v-model="search" />
                    </form>

                    <StartupsTable
                        v-if="startups.length"
                        :opportunity-id="opportunity.id"
                        :loading="startupsLoading"
                        :startups="startups"
                        :removing-id="removingStartupId"
                        @remove="removeStartup"
                        class="tabs-primary__inner"
                    />

                    <div class="text-center" v-else>
                        No startups found
                    </div>
                </div>
            </section>

            <aside class="page-startup__aside">
                <PostedBy :opportunity="opportunity"/>
            </aside>
        </main>
    </div>
</template>

<style scoped>

</style>
